import api from './api';

export const runInspectionAudit = () => api.post('/inspeccion/audit');
export const downloadAuditPdf = () =>
  api.post('/inspeccion/audit/pdf', null, { responseType: 'blob' });
export const generateInspectionPack = (opts) =>
  api.post('/inspeccion/pack', opts, { responseType: 'blob' });
export const listInspectionPacks = () => api.get('/inspeccion/packs');
export const listInspectionRequirements = () => api.get('/inspeccion/requirements');
export const createInspectionRequirement = (data) => api.post('/inspeccion/requirements', data);
export const updateInspectionRequirement = (id, data) => api.put(`/inspeccion/requirements/${id}`, data);
export const deleteInspectionRequirement = (id) => api.delete(`/inspeccion/requirements/${id}`);
export const aiAnalyzeRequirement = (text, file) => {
  const fd = new FormData();
  if (text) fd.append('text', text);
  if (file) fd.append('file', file);
  return api.post('/inspeccion/ai-analyze', fd);
};
